import { Field, FieldType } from '../models/field.model';
import { EditorComponent } from '../models/editor-component.model';
import { FieldTypeConfig } from '../models/field-type.model';

export interface FieldStrategy<T extends FieldTypeConfig = FieldTypeConfig> {
  getDefaultConfig(): T;
  createField(id: string): Field;
  getEditorConfig(config?: T): EditorComponent[];
  validateValue(value: any, config: T): boolean;
}

export abstract class BaseFieldStrategy<T extends FieldTypeConfig = FieldTypeConfig> implements FieldStrategy<T> {
  constructor(
    protected readonly type: FieldType,
    protected readonly label: string,
    protected readonly icon: string
  ) {}

  abstract getDefaultConfig(): T;

  createField(id: string): Field {
    const config = this.getDefaultConfig();
    return {
      ...config,
      id,
      key: `field_${id}`,
      label: 'New ' + this.label,
      value: null,
      required: false,
      readOnly: false,
      defaultValue: null
    };
  }

  abstract getEditorConfig(config?: T): EditorComponent[];
  abstract validateValue(value: any, config: T): boolean;
}
